import React from 'react';

import { useAllFromCollection } from '../../firebase/hooks';
import styles from './body.css';

const Body = () => {
	const [isLoading, texts] = useAllFromCollection('homepage-htmls');
	return (
		<div className={`uk-flex uk-flex-center ${styles.body}`}>
			<div className="uk-flex uk-flex-column uk-flex-center">
				{
					isLoading && (
						<h2 className={`uk-text-center ${styles.intro}`}>
							{'</>'}
						</h2>
					)
				}
				{
					texts.sort((a, b) => a.fields.position.integerValue - b.fields.position.integerValue).map(text => (
						<h2
							className={`uk-text-center ${styles.intro}`}
							key={text.name}
							dangerouslySetInnerHTML={{ __html: text.fields.content.stringValue }}
						/>
					))
				}
			</div>
		</div>
	);
};

export default Body;



// WEBPACK FOOTER //
// ./src/components/body/index.js